export default defineNuxtRouteMiddleware((to, _) => {
  if (import.meta.server) return

  if (!to.path.startsWith('/tablet')) {
    const authStore = useAuthStore()
    if (authStore.tabletMode) {
      return navigateTo('/tablet')
    }
  }
})
